import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MoreVertOutlined from "@mui/icons-material/MoreVertOutlined";
import { useNavigate } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";

const HelpCenterHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const mediumScreen = useMediaQuery("(max-width:1024px)");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#FC0108",
          padding: isMobile ? "0 10px" : "0 30px",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Left Section */}
          <Box display="flex" alignItems="center" gap={1}>
            <img
              src={require("../../assets/icons/logo (2).png")}
              style={{
                width: mediumScreen ? "100px" : "150px",
                height: "auto",
                cursor: "pointer",
              }}
              alt="logo"
              onClick={() => navigate("/dashboard")}
            />
            <Typography variant={isMobile ? "h6" : "h5"} component="div">
              Help Center
            </Typography>
          </Box>

          {/* Right Section */}
          <Box>
            {isMobile ? (
              <>
                <IconButton onClick={handleClick}>
                  <MoreVertOutlined sx={{ color: "white" }} />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    style: { marginTop: "40px" },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      navigate("/creator-hub");
                    }}
                  >
                    Visit Creator Hub
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      navigate("/submit-request");
                    }}
                  >
                    Submit a Request
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Button
                  variant="outlined"
                  sx={{
                    marginRight: 2,
                    borderColor: "white",
                    color: "white",
                    "&:hover": {
                      borderColor: "#ffcccc",
                      backgroundColor: "#ffcccc",
                      color: "#FC0108",
                    },
                  }}
                  onClick={() => navigate("/creator-hub")}
                >
                  VISIT CREATOR HUB
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "white",
                    color: "#FC0108",
                    "&:hover": { backgroundColor: "#ffcccc" },
                  }}
                  onClick={() => navigate("/submit-request")}
                >
                  SUBMIT A REQUEST
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default HelpCenterHeader;
